import {Component, ViewEncapsulation} from '@angular/core';
require('./subscribe.component.scss');

@Component({
  templateUrl: './subscribe.component.html',
  selector: 'subscribe',
  styleUrls: [ './subscribe.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class SubscribeComponent {

  public onSubmit(form: any){
    form.submit();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/subscribe/subscribe.component.ts